export const STATES = ['New South Wales', 'Victoria', 'Queensland', 'Western Australia', 'South Australia', 'Tasmania'];
export const statesCamelize = {
    newSouthWales: 'New South Wales',
    victoria: 'Victoria',
    queensland: 'Queensland',
    westernAustralia: 'Western Australia',
    southAustralia: 'South Australia', 
    tasmania: 'Tasmania'

}
export default STATES;
